import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';

export default function NoProfile() {
  const { t } = useTranslation();
  return (
    <>
      <Container>
        <Row>
          <Col className="p-5 text-center text-muted">{t('global.noProfiles')}</Col>
        </Row>
      </Container>
    </>
  );
}
